import { OrderProvider } from "components/serviceOrders/context/OrderContext";
import ExecutedServiceOrder from "./ExecutedServiceOrder";

const ExecutedServiceOrderContainer = ({
  serviceOrderId,
  viewType = "execute",
  fromEquipment = false,
  onSuccess,
}) => {
  return (
    <OrderProvider
      serviceOrderID={serviceOrderId}
      viewType={viewType}
      fromEquipment={fromEquipment}
    >
      <ExecutedServiceOrder onSuccess={onSuccess} />
    </OrderProvider>
  );
};

export default ExecutedServiceOrderContainer;
